import { NotificationProgrammatic as Notification } from 'buefy'

export const notifications = {
  methods: {
    wrong: (msg) => {
      Notification.open({
        duration: 5000,
        message: msg,
        position: 'is-bottom-right',
        type: 'is-danger',
        hasIcon: true
      })
    },

    sucess: (msg) => {
      Notification.open({
        duration: 5000,
        message: msg,
        position: 'is-bottom-right',
        type: 'is-success',
        hasIcon: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/notifications.js